<template>
  <div>
    <popup-add-automation ref="popupAddAutomation" />
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">Automations</h3>
        <p class="mt-5">
          Automations are based on the <i>When this then that</i> principle. You
          can create an automation that runs a list of actions when an event
          occurs.
        </p>
      </vs-col>
      <div>
        <vs-row>
          <vs-button
            ref="createButton"
            id="create-button"
            v-if="$AuthService.hasPermission('vp.crm.automations.edit')"
            class="vs-con-loading__container"
            @click="$refs.popupAddAutomation.show()"
            type="relief"
            color="primary"
            >New automation</vs-button
          >
        </vs-row>
      </div>
    </vs-row>

    <vs-row> </vs-row>

    <!-- table -->
    <div class="data-list-container data-list-list-view">
      <!-- <h3>{{ activeVenue.name }}</h3> -->

      <vs-table
        max-items="30"
        ref="table"
        class="mt-8"
        v-model="selected"
        pagination
        search
        :data="automationsFiltered"
        @selected="onClicked(selected.id)"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <venue-selector
              v-model="filterVenues"
              style="width: 350px"
              :multiple="true"
            />
          </div>

          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th>Preview</vs-th>
          <vs-th>Venue(s)</vs-th>
          <vs-th>Name</vs-th>
          <vs-th>Category</vs-th>
          <vs-th>When</vs-th>
          <vs-th>Then do</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <action-timeline-preview :automationId="tr.id" />
              </vs-td>
              <vs-td>
                <p class="product-category">
                  {{
                    tr.limitVenues
                      ? tr.venues.length === 1 ? userVenues.find(e => e.venueId === tr.venues[0]).name : tr.venues.length + " venue(s)"
                      : "All venues"
                  }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-category">
                  {{ tr.name }}
                </p>
              </vs-td>

              <vs-td>
                <vs-chip color="warning" class="product-order-status">
                  {{ tr.category }}
                </vs-chip>
              </vs-td>

              <vs-td>
                <vs-chip color="primary" class="product-order-status">
                  {{ triggerTypes[tr.triggerType] }}
                </vs-chip>
              </vs-td>

              <vs-td>
                <p class="status-category">
                  <vs-chip color="primary" class="status-circle"></vs-chip>
                  {{ tr.actions.length }} actions
                </p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PopupAddAutomation from "./PopupAddAutomation.vue";
import ActionTimelinePreview from "./Automation/Actions/ActionTimelinePreview.vue";
import VenueSelector from "@/components/VenueSelector.vue";
export default {
  components: { PopupAddAutomation, ActionTimelinePreview, VenueSelector },
  data() {
    return {
      selected: [],
      filterVenues: [],
    };
  },
  methods: {
    onClicked(id) {
      this.$router
        .push({
          name: "crm-automation",
          params: { id: id },
        })
        .catch((e) => {
          console.log("Automation lookup", e);
        });
    },
  },
  computed: {
    ...mapGetters({
      automations: "automations/automations",
      userVenues: "venues/venues",
      triggerTypes: "automations/triggerTypes",
    }),
    automationsFiltered() {
      return this.filterVenues.length > 0
        ? this.automations.filter(
            (e) =>
              e.limitVenues &&
              e.venues.some((vId) => this.filterVenues.includes(vId))
          )
        : this.automations;
    },
  },

  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("automations/getAll");
    this.$vs.loading.close();
  },
};
</script>